export const getCurrentEnv = () => {
  if (!window.marmotInjectInfo?.env) {
    return 'LOCAL';
  }
  // DEV TEST PRE PROD
  return window.marmotInjectInfo.env
}
const env = getCurrentEnv();
// 前端 <-> 服务端域名映射
const SERVER_URL_MAP: Record<string, string> = {
  LOCAL: 'http://local.dev.alipay.net',
  DEV: 'http://server.dev.alipay.net', // DEV
  TEST: 'http://server.stable.alipay.net', //STABLE
  PRE: 'https://server-pre.alipayplus.com', // PRE
  PROD: 'https://server.alipayplus.com', // PROD
}
const DEFAULT_SERVER_DOMAIN = SERVER_URL_MAP.PROD;
export const baseURL = SERVER_URL_MAP[env] || DEFAULT_SERVER_DOMAIN;
